export default "__VITE_ASSET__CJ4xuRiK__"